import { render, staticRenderFns } from "./addressListModel.vue?vue&type=template&id=c492465a&scoped=true&"
import script from "./addressListModel.vue?vue&type=script&lang=js&"
export * from "./addressListModel.vue?vue&type=script&lang=js&"
import style0 from "./addressListModel.vue?vue&type=style&index=0&id=c492465a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c492465a",
  null
  
)

export default component.exports